import React, { use } from "react";
import "./StoreLandingPage.scss";
import { useDispatch, useSelector } from "react-redux";
import { get_lang } from "../../../../global-functions/apiGlobal";
import { useTranslation } from "react-i18next";
import enabill from "../../assets/images/loadingEnabill.svg";
import { Button, IconButton } from "@material-ui/core";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../../../redux-store/store";

const StoreLandingPage = (props) => {
  const { t } = useTranslation();
  const appState = useSelector((state) => state);
  const appDispatch = useDispatch();
  const { langValue } = appState;
  const { setShowLandingPage } = props;
  const { landingPageBackgroundType, landingPageBackgroundValue, landingPageLogo } = appState.storeInfo
  const { setLangValue } = bindActionCreators(actionCreators, appDispatch);
  const handleStartOrdering = () => {
    console.log("first  ", landingPageBackgroundType, landingPageBackgroundValue, landingPageLogo);
    setShowLandingPage(false);
  };
  return (
    <section
      id="store-landing-page"
      style={{
        background: landingPageBackgroundType == 'image' ? `url(${landingPageBackgroundValue}) center center / cover no-repeat` : landingPageBackgroundType == 'color' ? landingPageBackgroundValue : `url(${appState.storeInfo.cover}) center center / cover no-repeat`,
      }}
    >
      {/* {appState.storeInfo.cover} */}
      <div className="store-header">
        <div className="d-flex align-items-center w-100 justify-content-end">
          {appState.langValue == "ar" ? (
            <Button
              variant="outlined"
              size="small"
              className="lang-btn"
              id="headerBtn"
              onClick={(e) => setLangValue("en")}
            >
              EN
            </Button>
          ) : (
            <Button
              variant="outlined"
              size="small"
              className="lang-btn"
              id="headerBtn"
              onClick={(e) => setLangValue("ar")}
            >
              عربي
            </Button>
          )}
        </div>

        <div className="store-header-content">
          {/* Logo */}
          <div className="store-logo mb-5">
            <img src={ landingPageLogo ? landingPageLogo : appState.storeInfo.logo} alt="Store Logo" width={350} />
          </div>
          <span className="mt-5">
            {/* Store Name */}
            <h1 className="store-name mb-1">
              {get_lang(appState.storeInfo?.businessName, langValue)}
            </h1>
          </span>
          {/* Menu Button */}
          <button
            className="start-order-btn mt-1  "
            onClick={handleStartOrdering}
          >
            {t("Start Ordering")}
          </button>
        </div>

        {/* Footer */}
        <div className="powered-by d-flex align-items-center justify-content-center">
          <span
            className={`mx-1 pt-1 ${appState.langValue == "ar" ? "" : "pt-1"}`}
          >
            {t("Pay Securely with")}
          </span>
          <img src={enabill} alt="enabill  " width={70} />
        </div>
      </div>
      <div className="overlay"></div>
    </section>
  );
};

export default StoreLandingPage;
